const STORAGE_PREFIX = "naf.wireFraudFs";

export const wireFraudFullStoryStorageKey = (
  userId: string,
  nhDealApplicationId: string,
  eventName: string,
) => `${STORAGE_PREFIX}:${userId}:${nhDealApplicationId}:${eventName}`;

export const hasPersistedWireFraudFullStoryEvent = (
  userId: string,
  nhDealApplicationId: string,
  eventName: string,
) => {
  try {
    return localStorage.getItem(wireFraudFullStoryStorageKey(userId, nhDealApplicationId, eventName)) === "1";
  } catch {
    return false;
  }
};

export const persistWireFraudFullStoryEvent = (
  userId: string,
  nhDealApplicationId: string,
  eventName: string,
) => {
  try {
    localStorage.setItem(wireFraudFullStoryStorageKey(userId, nhDealApplicationId, eventName), "1");
  } catch {
    // Private browsing can block storage. The in-memory set still blocks this page.
  }
};

export const clearPersistedWireFraudFullStoryEvent = (
  userId: string,
  nhDealApplicationId: string,
  eventName: string,
) => {
  try {
    localStorage.removeItem(wireFraudFullStoryStorageKey(userId, nhDealApplicationId, eventName));
  } catch {
    // Ignore storage failures. The caller also drops the in-memory key.
  }
};
